import { render, staticRenderFns } from "./DxPlanningForm.vue?vue&type=template&id=3189a722&"
import script from "./DxPlanningForm.vue?vue&type=script&lang=js&"
export * from "./DxPlanningForm.vue?vue&type=script&lang=js&"
import style0 from "./DxPlanningForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports